import { Box, List, ListItem, ListItemIcon, ListItemText, Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Icon } from '@malash-office/ui-components';
import { NavChild } from './navConfig';

interface FlyoutMenuProps {
  items: NavChild[];
  drawerWidth: number;
  onNavigate: (to: string) => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

/** Sub-page panel that slides out to the left of the right rail (matches the reference). */
export const FlyoutMenu = ({ items, drawerWidth, onNavigate, onMouseEnter, onMouseLeave }: FlyoutMenuProps) => (
  <Paper
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    sx={{
      position: 'absolute',
      top: 0,
      left: `calc(${drawerWidth}px + 16px)`,
      minWidth: drawerWidth * 2,
      height: 'calc(100% - 32px)',
      mt: 2,
      boxSizing: 'border-box',
      borderRadius: 2,
      boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.25)',
      py: 1,
      zIndex: 1300,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'primary.main',
      animation: 'slideIn 0.3s ease-out',
      '@keyframes slideIn': {
        '0%': { opacity: 0, transform: 'translateX(-20px)' },
        '100%': { opacity: 1, transform: 'translateX(0)' }
      }
    }}
  >
    <List sx={{ pt: 3, px: 1, flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
      {items.map(item => (
        <Box key={item.to} sx={{ mb: 0.5 }}>
          <ListItem
            onClick={() => onNavigate(item.to)}
            sx={{
              fontSize: 13,
              pl: 1,
              color: 'common.white',
              cursor: 'pointer',
              alignItems: 'center',
              gap: 1,
              backgroundColor: theme => alpha(theme.palette.common.white, 0.1),
              borderRadius: '7px',
              '&:hover': { backgroundColor: theme => alpha(theme.palette.common.white, 0.25) }
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: 0.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 28,
                height: 28,
                border: '1px solid',
                borderColor: theme => alpha(theme.palette.common.white, 0.2),
                backgroundColor: theme => alpha(theme.palette.common.white, 0.3),
                borderRadius: '4px'
              }}
            >
              <Icon icon={item.icon} size="small" color="primary.main" />
            </ListItemIcon>
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{ variant: 'caption' }}
              sx={{ flex: 'unset', width: 'auto', m: 0, p: 0 }}
            />
          </ListItem>
        </Box>
      ))}
    </List>
  </Paper>
);

export default FlyoutMenu;
